import RadialChart from "@/src/components/CommonCharts/RadialChart";
import {
  HUD_STATS_PROP_LBL_CLR_MAP,
  RADIAL_CHART_SEMI_CONFIG,
} from "@/src/constants/StatsCornerConstants";
import styles from "../Stats.module.css";
import { isA23 } from "../Stats";
import  CircularProgressBar  from "@/src/components/CommonCharts/CircularProgressBar";

export const PotContriStats = ({
  hudStatsRadialBarArr,
  hudStats,
  gradientArr,
}) => {
  if (!hudStats || Object.keys(hudStats).length === 0) return null;
  return (
    <div className="vpip-pfr-section grid grid-cols-2 gap-[12px] mt-[12px]">
      {hudStatsRadialBarArr.map(
        (item) =>
          hudStats.hasOwnProperty(item) &&
          !isNaN(Number(hudStats?.[item])) && (
            <div
              key={item}
              className={`flex flex-col ${
                isA23
                  ? styles.cardConfig
                  : styles.coreCardConfig + " p-3 " + styles.coreCardAddaShadow
              }`}
            >
              <div className={styles.statTitle}>
                {HUD_STATS_PROP_LBL_CLR_MAP[item].label}
              </div>
              <div className={styles.statDescription}>
                {HUD_STATS_PROP_LBL_CLR_MAP[item].description}
              </div>
              <div className="place-self-end h-[58px] w-[58px]">
                <CircularProgressBar
                progress={hudStats?.[item]}
                type={item}
              />
              </div>
            </div>
          )
      )}
    </div>
  );
};
